import Typography from "@material-ui/core/Typography";
/* eslint-disable react/display-name */
import React, { FC, memo } from "react";
import { GridCellEditCommitParams, GridColDef } from "@material-ui/data-grid";

import BaseDataGrid from "../../../../../components/modules/BaseDataGrid";
import Switch from "../../../../../components/elements/Switch";
import classes from "./EditCustomDomainListDashboard.module.scss";
import { Domain } from "../../../../../types/campaignTypes";

type EditCustomDomainListDashboardProps = {
  domains: Domain[];
  setFormikFieldValue: (field: string, value: any) => void;
};

const EditCustomDomainListDashboard: FC<EditCustomDomainListDashboardProps> = ({ domains, setFormikFieldValue }) => {
  const handleDomainCellChange = (params: GridCellEditCommitParams) => {
    const { id, value } = params;
    const editingCellIndex = domains.findIndex((domain) => domain.brandgenItemId === id);
    setFormikFieldValue(`domainsToUpdate[${editingCellIndex}].domain`, value);
  };

  const handleActiveCellChange = (id: string, active: boolean) => () => {
    const editingCellIndex = domains.findIndex((domain) => domain.brandgenItemId === id);
    setFormikFieldValue(`domainsToUpdate[${editingCellIndex}].active`, !active);
  };

  const columns: GridColDef[] = [
    {
      field: "domain",
      headerName: "Domain (Double click to Edit)",
      width: 450,
      editable: true,
      sortable: false,
      filterable: false,
      hide: false,
    },
    {
      field: "active",
      headerName: "Active",
      width: 450,
      sortable: false,
      filterable: false,
      hide: false,
      renderCell: (params: any) => (
        <Switch
          checked={params.row.active}
          onChange={handleActiveCellChange(params.row.id as string, params.row.active as boolean)}
        />
      ),
    },
  ];

  const rows = domains
    .sort((a, b) => Date.parse(b.createdAt) - Date.parse(a.createdAt))
    .map(({ domain, active, brandgenItemId }) => ({
      id: brandgenItemId,
      domain,
      active,
    }));

  return (
    <div className={classes.container}>
      <Typography variant="h2">Domains</Typography>
      <BaseDataGrid columns={columns} rows={rows} onCellEditCommit={handleDomainCellChange} disableColumnSelector />
    </div>
  );
};

export default memo(EditCustomDomainListDashboard);
